import React, { useEffect } from "react";
import { 
    AlertCircle,
    CircleCheck,
    Clock,
    Heart,
    Plus,
    ArrowLeft,
} from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import SupportTicket from "./components/SupportTicket";
import SupportTabs from "./components/SupportTabs";
import PopupButton from "components/button/PopupButton";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
    getTicketDepartmentMatrix
} from "../../../../redux/overview/overviewState";

const HRSupport = ({ getList, recordList }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const navFromQuickAccess = location.state?.fromQuickAccess;

    useEffect(() => {
        getList(); 
    }, [getList]);

    useEffect(() => {
            if (recordList && recordList.length > 0) {
                console.log('Data loaded:', recordList);
                console.log('Available department names:', recordList.map(d => d.department_name));
            }
        }, [recordList]);

    const hrDepartment = recordList?.find(d => d.department_name === "HR");
    
    const open = hrDepartment?.open || 0;
    const inProgress = hrDepartment?.in_progress || 0;
    const resolved = hrDepartment?.resolved || 0;

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">

                {navFromQuickAccess && (
                    <button
                        onClick={() => navigate("/console/dashboard")}
                        className="flex items-center border rounded-xl px-2 py-1 gap-2 dark:text-white mb-4"
                    >
                        <ArrowLeft className="w-4 h-4 dark:text-white"/>
                        Back to Dashboard
                    </button>
                )}

                <SummaryHeader
                    title={"People & Culture"}
                    icon={Heart}
                    description={"Technical assistance and troubleshooting"}
                    color={"bg-pink"}
                    rightNav={
                        <PopupButton 
                            id="add_ticket" 
                            title="Submit People & Culture Ticket"
                            description="Share your HR questions, benefits inquiries, or workplace concerns"
                            label="New Ticket" 
                            btnClass="ticket btn-ticket pink" 
                            action="add"
                            moduleId={0}
                            icon={Plus}
                            useCustomClass={true}
                            modalWidth={500}
                        >
                            <SupportTicket recordId="0" mode="edit"/>
                        </PopupButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Open Tickets"
                            icon={<AlertCircle />}
                            display={open}
                        />
                        <SummaryItem
                            title="In Progress"
                            icon={<Clock />}
                            display={inProgress} 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display={resolved} 
                        />
                   </div>
                </SummaryHeader>
                <SupportTabs />
            </div>
        </div>
    )
};

const mapStateToProps = (state) => ({
    recordList: state.overview.ticketDepartmentMatrix?.data,
});

const mapDispatchToProps = (dispatch) => ({
    getList: (filters) => dispatch(getTicketDepartmentMatrix(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HRSupport);